import axios from 'axios';
import type { ApiResponse } from '@/types/api.ts';

class OnboardingAPI {
    async completeOnboarding(): Promise<ApiResponse<void>> {
        try {
            await axios.patch('/api/user/complete-onboarding');
            return { success: true };
        } catch (error: any) {
            return {
                success: false,
                error: error.response?.data?.message || error.message || 'Greška pri završavanju onboardinga'
            };
        }
    }
}

const onboardingAPI = new OnboardingAPI();
export default onboardingAPI;
